import React, { FC, useState } from 'react';
import { TabView, TabBar } from 'react-native-tab-view';
import { ConversationScreen } from '../conversationScreen';
import { Container, MainHeader, FloatButton } from 'components/src';
import { Platform, createUseStyles, routesName } from 'core/src';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { useTranslation } from 'react-i18next';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;

interface TabProps {
  navigation: any;
  setOpen?: any;
  dispatch?: any;
  setInfo?: any;
  setOpenChat?: any;
  chatInfo?: any;
}

const TabNavigator: FC<TabProps> = ({
  navigation,
  setOpen,
  setOpenChat,
  dispatch,
  setInfo,
  chatInfo,
}) => {
  const { colors } = useStyles();
  const { i18n } = useTranslation();

  const [index, setIndex] = useState(0);
  const [routes] = useState([
    { key: 'all', title: i18n.t('allChat') },
    { key: 'private', title: i18n.t('private') },
    { key: 'group', title: i18n.t('group') },
    { key: 'channel', title: i18n.t('channel') },
  ]);

  const renderScene = () => {
    return (
      <ConversationScreen
        navigation={navigation}
        dispatching={dispatch}
        setInfo={setInfo}
        chatInfo={chatInfo}
        setOpenChat={setOpenChat}
      />
    );
  };

  const handleButtonPress = () => {
    Platform.isDesktop
      ? setOpen('contact')
      : navigation.navigate(routesName.CONTACT);
  };

  return (
    <Container classes={{ direction: 'ltr' }}>
      <MainHeader setOpen={setOpen} navigation={navigation} />
      <TabView
        navigationState={{ index, routes }}
        renderScene={renderScene}
        onIndexChange={setIndex}
        renderTabBar={(props) => (
          <TabBar
            {...props}
            indicatorStyle={{ backgroundColor: 'pink' }}
            style={{
              backgroundColor: colors.menu,
              direction: 'ltr',
            }}
          />
        )}
      />
      <FloatButton onClick={handleButtonPress}>
        <MaterialIconsX name="edit" size={25} color={colors.white} />
      </FloatButton>
    </Container>
  );
};

const useStyles = createUseStyles(({ colors, theme }) => ({}));

export { TabNavigator };
